module.exports = __webpack_public_path__ + "static/img/img3.34784ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approve/img3.jpg
// module id = rBaU
// module chunks = 1